module.exports = __webpack_public_path__ + "static/showcase_rentforaweek-d72fd219c3b58fb05250a08837b105ea.mp4";